/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { getType } from "typesafe-actions";
import { AppAction } from "..";
import { IdentityToken, OAuthConfiguration } from "../../utils/auth";
import { fetchOAuthConfigActions, fetchTokenActions, signOutAction } from "./actions";
import { fetchUserDetails } from '../users';
import { CURRENT_USER } from '../../utils/types';

export interface SessionState {
  dfdmToken: IdentityToken | null;
  isSigningIn: boolean;
  isAuthorized?: boolean;
  error?: Error;
  oauth: OAuthConfiguration | null;
  currentUserFetched: boolean;
}

const initialOAuthConfig = localStorage.getItem("authConfig");

function isUserAuthorized(token: IdentityToken): boolean {
  const scopes = token.scope.split(" ");
  // temporary backwards compatibility of tokens (migrating from evaluations claim -> certifications claim)
  if (
    (!scopes.includes("evaluations") && !scopes.includes("certifications")) ||
    (token.evaluations === undefined && token.certifications === undefined)
  ) {
    return false;
  }

  const legacyValidTraining =
    Object.values(token.evaluations).findIndex(
      certifications =>
        certifications.findIndex(certStatus => certStatus !== "expired") >= 0
    ) >= 0;

  let validTraining = false;
  
  if (token.certifications) {
    Object.values(token.certifications).forEach(value => {
      if (value.allow_read) {
        validTraining = true;
      }
    })
  }

  return legacyValidTraining || validTraining;
}

export const sessionReducer: (
  state: SessionState | undefined,
  action: AppAction
) => SessionState = (
  state = {
    dfdmToken: null,
    isSigningIn: false,
    oauth: initialOAuthConfig === null ? null : JSON.parse(initialOAuthConfig),
    isAuthorized: undefined,
    currentUserFetched: localStorage.getItem(CURRENT_USER) !== null
  },
  action
) => {
  switch (action.type) {
    // case getType(signInActions.request):
    //   return {
    //     userId: null,
    //     isSigningIn: true,
    //   };
    // case getType(signInActions.success):
    //   return {
    //     userId: "trainee",
    //     isSigningIn: false,
    //     error: undefined,
    //   };
    // case getType(signInActions.failure):
    //   return {
    //     userId: null,
    //     isSigningIn: false,
    //     error: action.payload,
    //   };
    case getType(fetchUserDetails.success):
      return {
        ...state,
        currentUserFetched: true
      }

    case getType(fetchOAuthConfigActions.success):
      return {
        ...state,
        oauth: action.payload
      };

    case getType(fetchTokenActions.success):
      const { dfdmToken } = action.payload;

      return {
        ...state,
        dfdmToken,
        isSigningIn: false,
        error: undefined,
        isAuthorized: isUserAuthorized(dfdmToken)
      };

    case getType(signOutAction):
      return {
        ...state,
        dfdmToken: null,
        isSigningIn: false,
        error: undefined,
        isAuthorized: undefined,
        currentUserFetched: false
      };

    default:
      return state;
  }
};
